import React, { useRef, useEffect, useState } from "react";
import styles from "../styles/Wallet.module.css";
import remit from "../assets/wallet2.jpg";
import Rem from "../assets/Rem.jpg";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Link } from "react-router-dom";

const Wallet = () => {
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  const slides = [
    {
      title: "Smart & Flexible Payments",
      text: "Pay confidently with cross-platform payments, easy bill splitting, and automated schedules.",
    },
    {
      title: "Credit Access, Simplified",
      text: "Need a financial boost? Apply instantly, track approval in real time, and get smart repayment reminders—no bank visits needed.",
    },
    {
      title: "Shop Inside the Wallet",
      text: "Enjoy a full web shopping experience—browse trusted vendors, checkout from your wallet, and track deliveries in real time.",
    },
    {
      title: "Insurance in Seconds",
      text: "Get protected in a few taps—enroll instantly, manage claims, and cover health, devices, travel, and more right from the app.",
    },
  ];

  // Detect mobile on mount and resize
  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  // Auto-scroll effect on mobile
  useEffect(() => {
    if (!isMobile) return;

    const slider = sliderRef.current;
    if (!slider) return;

    const slidesElements = Array.from(slider.children);
    const slidePositions = slidesElements.map((slide) => slide.offsetLeft);

    let index = 0;

    const startAutoScroll = () => {
      intervalRef.current = setInterval(() => {
        if (!slider) return;
        index = (index + 1) % slidePositions.length;
        slider.scrollTo({
          left: slidePositions[index],
          behavior: "smooth",
        });
      }, 3000);
    };

    const stopAutoScroll = () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };

    slider.addEventListener("touchstart", stopAutoScroll);
    slider.addEventListener("touchend", startAutoScroll);

    startAutoScroll();

    return () => {
      stopAutoScroll();
      slider.removeEventListener("touchstart", stopAutoScroll);
      slider.removeEventListener("touchend", startAutoScroll);
    };
  }, [isMobile, slides.length]);

  return (
    <div>
      <Header />
      <section className={styles.hero}>
        <div className={styles.heroLeft}>
          <p
            style={{
              color: "green",
              fontSize: "30px",
              fontWeight: "bold",
            }}
          >
            DIGITAL WALLET
          </p>
          <h1 style={{ marginTop: "20px" }}>
            One Wallet, Unlimited Possibilities
          </h1>
          {/* <Link to="/pages/ContactUs">
            <button className={styles.primaryButton}>Get Started →</button>
          </Link> */}
        </div>
        <div className={styles.heroRight}>
          <img
            src={remit}
            alt="Payment Devices"
            style={{
              width: "100%",
              maxWidth: "450px",
              height: "300px",
              borderRadius: "20px",
              marginTop: "50px",
            }}
          />
        </div>
      </section>

      <section className={styles.solutionSection}>
        <div className={styles.keyFeature}>
          <p style={{ fontSize: "2em", marginBottom:"0" }} className={styles.sectionLabel}>
            KEY FEATURE
          </p>
          <h2
            className={styles.sectionHead}
            style={{ fontSize: "2.3rem", color: "black", marginBottom: "20px" }}
          >
            Effortless Financial Control at Your Fingertips
          </h2>
          <p
            className={styles.paragra}
            style={{
              fontSize: "1.2rem",
              color: "black",
              textAlign: "center",
            }}
          >
            Our wallet is designed to meet
            <span className={styles.breakPoint}>
              <br />
            </span>{" "}
            everyday financial needs — whether you're shopping,{" "}
            <span className={styles.responsiveBreak}>
              <br />
            </span>
            sending money, borrowing, or protecting your essentials.
          </p>
        </div>

        <section className={styles.slidContainer}>
          <div ref={sliderRef} className={styles.sliderWrapper}>
            {slides.map((slide, index) => (
              <div key={index} className={styles.slideBox}>
                <h3
                  style={{
                    fontSize: "24px",
                    color: "green",
                    marginBottom: "20px",
                  }}
                >
                  {slide.title}
                </h3>
                <p style={{ fontSize: "17px", color: "black" }}>{slide.text}</p>
              </div>
            ))}
          </div>
        </section>

        <div className={styles.experience}>
          <div className={styles.howItwork}>
            <h2 style={{ fontSize: "26px", color: "green", marginBottom: "0" }}>
              How it works?
            </h2>

            <p style={{ fontSize: "24px", fontWeight:'bold', marginTop: "0" }}>
              It’s as easy as 1, 2, 3, 4.
            </p>
          </div>

          <div className={styles.steps}>
            {/* Column 1 */}
            <div className={styles.column}>
              <div>
                {/* <div className={styles.separatorVertical}></div> */}
                <p style={{ fontSize: "24px", color: "green", marginBottom:'10px' }}>STEP 1</p>
                <h4 style={{ fontSize: "20px", marginTop:'0', marginBottom:'10px' }}>Sign Up</h4>
                <p
                  className={styles.paragraph}
                  style={{ fontSize: "17px", color: "black" , marginTop:'0'}}
                >
                  Create your account with your basic details.
                </p>
              </div>

              <div>
                {/* <div className={styles.separatorVertical}></div> */}
                <p style={{ fontSize: "24px", color: "green", marginBottom:'10px' }}>STEP 2</p>
                <h4 style={{ fontSize: "20px", marginTop:'0', marginBottom:'10px' }}>Explore Features</h4>
                <p
                  className={styles.paragraph}
                  style={{ fontSize: "17px", color: "black" }}
                >
                  Choose services like payments, shopping, or loans.
                </p>
                {/* <div className={styles.separatorVertical}></div> */}
              </div>
            </div>

            {/* Column 2 */}
            <div className={styles.column}>
              <div>
                {/* <div className={styles.separatorVertical}></div> */}
                <p style={{ fontSize: "24px", color: "green", marginBottom:'10px' }}>STEP 3</p>
                <h4 style={{ fontSize: "20px", marginTop:'0', marginBottom:'10px' }}>Make a Move</h4>
                <p
                  className={styles.paragraph}
                  style={{ fontSize: "16px", color: "black" }}
                >
                  Pay, shop, borrow, or insure —
              
                  instantly.
                </p>
              </div>

              <div>
                {/* <div className={styles.separatorVertical}></div> */}
                <p style={{ fontSize: "24px", color: "green", marginBottom:'10px' }}>STEP 4</p>
                <h4 style={{ fontSize: "20px", marginTop:'0', marginBottom:'10px' }}>Track Everything</h4>
                <p
                  className={styles.paragraph}
                  style={{ fontSize: "16px", color: "black" }}
                >
                  Stay updated with real-time
                
                  activity and receipts.
                </p>
                {/* <div className={styles.separatorVertical}></div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 65px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "2em",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                Everything fast, secure, and available 24/7.
              </h2>
            </div>

            {/* Image Side */}
            <div
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={Rem}
                alt="Wallet"
                style={{
                  width: "350px",
                  height: "200px",
                  borderRadius: "20px",
                }}
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Wallet;
